import flattenStudentGrades from './flattenStudentGrades';
import getOverrideOptions from './getOverrideOptions';
import getLastOverride from './getLastOverride';

const mergeGrades = ({
  assignmentGrades,
  assessmentItems,
  assessmentItemId,
  hasAwaitingDecision,
}) => {
  // return early if no assessment item selected for exporting
  if (
    !assessmentItemId ||
    !assessmentItems ||
    !assessmentItems.length ||
    !assignmentGrades
  ) {
    return [];
  }

  const { mappedAssignments, studentGrades, lastJob } = assessmentItems.find(
    ({ id }) => id === assessmentItemId
  );

  // return early if no studentGrades
  // it can happen if the request to fetch studentGrades fails
  if (!studentGrades) {
    return [];
  }

  const mappedAssignmentIds = mappedAssignments.map(({ id }) => id);

  const studentAssignmentGrades = flattenStudentGrades({
    assignmentGrades,
    mappedAssignmentIds,
  });

  return studentGrades.map((studentGrade) => ({
    ...studentGrade,
    overrideOptions: getOverrideOptions({
      studentGrade,
      hasAwaitingDecision,
    }),
    selectedOverrideValue: getLastOverride({
      studentGrade,
      lastJob,
    }),
    assignmentGrades: studentAssignmentGrades[studentGrade.studentId],
  }));
};

export default mergeGrades;
